import React from 'react';
import PasswordPage from '../../features/password/PasswordPage';
export default function PasswordForgot() {
  return <PasswordPage mode="forgot" />;
}
